import React, { useState, useEffect } from 'react'

import { LegendKey, LEGEND_SHAPE } from './legend-key'
import { useStyles } from './legend-content.style'

export const LegendContent = function ({ labels, colors, shape = LEGEND_SHAPE.CIRCLE, toggleDefaults, onToggle }) {
  const classes = useStyles()
  const [toggleState, setToggleState] = useState(toggleDefaults || {})

  useEffect(() => {
    setToggleState(toggleDefaults)
  }, [toggleDefaults])

  function handleToggle (label) {
    const state = {
      ...toggleState,
      [label]: !toggleState[label]
    }

    // Prevent all legend keys from being toggled off
    if (labels.every((label) => (state[label]))) {
      return
    }

    setToggleState(state)
    onToggle(state)
  }

  // Hide when there's only one label
  if (labels.length <= 1) {
    return null
  }

  return (
    <div className={classes.legend}>
      {labels.map((label, index) => {
        if (onToggle) {
          return (
            <a key={label} className={classes.legendKeyToggle} onClick={() => { handleToggle(label) }}>
              <LegendKey label={label} color={colors[index]} shape={shape} disabled={toggleState && toggleState[label]} />
            </a>
          )
        } else {
          return (
            <div key={label} className={classes.legendKey}>
              <LegendKey label={label} color={colors[index]} shape={shape} />
            </div>
          )
        }
      })}
    </div>
  )
}
